import { css } from '@emotion/core';
import { applyFont, media, tokens } from '@domain-group/fe-brary';
var colors = tokens.colors,
  spacing = tokens.spacing,
  typography = tokens.typography;
export var footer = /*#__PURE__*/css("display:flex;flex-direction:column;gap:", spacing.m, ";padding-top:8px;");
export var details = /*#__PURE__*/css("display:flex;flex-direction:column;justify-content:space-between;", media('>=tablet'), "{flex-direction:row;}");
export var countPlug = /*#__PURE__*/css("display:flex;flex-direction:column;gap:", spacing.xxs, ";");
export var count = /*#__PURE__*/css(applyFont(typography.mini), ";color:", colors.neutral.heavy.default, ";");
export var plug = /*#__PURE__*/css("display:flex;flex-direction:row;gap:", spacing.xs, ";");
export var plugText = /*#__PURE__*/css(applyFont(typography.mini), ";color:", colors.neutral.medium.default, ";");
export var logo = {
  name: "1eqmq6c",
  styles: "width:70px;"
};
export var button = /*#__PURE__*/css("display:none;", media('>=tablet'), "{display:inline-flex;width:210px;}");
export var buttonMobile = /*#__PURE__*/css("width:100%;margin:16px 0;", media('>=tablet'), "{display:none;}");
export var buttonIcon = transform => /*#__PURE__*/css("transform:", transform ? 'rotate(0deg)' : 'rotate(180deg)', ";transition:transform 0.3s;");